const config = {
  Host: '/api',
};
export default config;
